export default __webpack_public_path__ + "static/media/speaker-belen-narvaez.942147e1.jpg";